import * as I from "immutable";

import { Action } from "../actions";
import { ProfileData } from "../service/Data";
import { sameSet } from "../utils/immutable";

export interface Store extends ProfileData {}

export function initialStore(): Store {
    return {};
}

export function update(store = initialStore(), action: Action): Store {
    switch (action.type) {
        default: {
            return store;
        }
    }
}

export type OuterStore = { profile: Store };

export function getAllNotificationsDisabledUntilTs(store: OuterStore) {
    const value = store.profile.all_notifications_disabled_until_ts;
    return typeof value === "number" ? value : 0;
}

export function getFollowNotificationsDisabledUntilTs(store: OuterStore) {
    const value = store.profile.follow_notifications_disabled_until_ts;
    return typeof value === "number" ? value : 0;
}

export function areAllNotificationsDisabled(store: OuterStore) {
    const untilTs = getAllNotificationsDisabledUntilTs(store);
    return untilTs === -1 || untilTs > Date.now() / 1000;
}

export function areFollowNotificationsDisabled(store: OuterStore) {
    const untilTs = getFollowNotificationsDisabledUntilTs(store);
    return untilTs === -1 || untilTs > Date.now() / 1000;
}

export function getRoomMutedEverythingUntil(store: OuterStore, room_id: string | undefined) {
    const value = store.profile[`all_notifications_disabled_until_ts/${room_id}`];
    return typeof value === "number" ? value : 0;
}

export function getRoomMutedNonMentionsUntil(store: OuterStore, room_id: string | undefined) {
    const value = store.profile[`follow_notifications_disabled_until_ts/${room_id}`];
    return typeof value === "number" ? value : 0;
}

export function getHasRoomMutedEverything(store: OuterStore, room_id: string | undefined) {
    const value = getRoomMutedEverythingUntil(store, room_id);
    if (value > Date.now() / 1000 || value === -1) {
        return true;
    }
    return false;
}

export function getHasRoomMutedNonMentions(store: OuterStore, room_id: string | undefined) {
    const value = getRoomMutedNonMentionsUntil(store, room_id);
    if (value > Date.now() / 1000 || value === -1) {
        return true;
    }
    return false;
}

export function getIsRoomMuted(store: OuterStore, room_id: string | undefined) {
    return getHasRoomMutedEverything(store, room_id) || getHasRoomMutedNonMentions(store, room_id);
}

const getMutedRoomIdsCache = sameSet<string>();

export function getMutedRoomIds(store: OuterStore) {
    const now = Date.now() / 1000;
    const roomIds = Object.entries(store.profile)
        .filter(([_, value]) => typeof value === "number" && (value > now || value === -1))
        .map(([key, _]) => {
            const match = key.match(/^(all|follow)_notifications_disabled_until_ts\/(\S+)$/);
            return match && match[2] ? match[2] : undefined;
        })
        .filter((x): x is string => x !== undefined);

    return getMutedRoomIdsCache(I.Set(roomIds));
}
